export function isPositiveInteger(x: number) {
  return Number.isInteger(x) && x > 0;
}
